import {Empty, Loader, ProfileCircleIcon} from 'common/components'
import { IRoleRecord } from '../type'
import { useQueryRoles } from '../api/roles'
import { useStore, setSearchKeyWords, setSort, setPageNumber } from '../store/roles'
import { useStore as useSessionStore } from '../store/session'
import { ListPanel } from './ListPanel'
import { List } from './List'
import { useEffect } from 'react'

export default function RolesList() {
  const tokens = useSessionStore((state) => state.tokens)
  const search = useStore((state) => state.searchKeyWords)
  const sort = useStore((state) => state.sort)
  const page = useStore((state) => state.pageNumber)
  const {data, refetch} = useQueryRoles({
    pageNumber: page,
    sort,
    searchKeyWords: search.trim(),
  })
  // console.log(data)

  useEffect(() => {
    // console.log(tokens?.access)
    if (!!tokens?.access?.token) {
      refetch()
    }
  }, [tokens?.access])

  return (
    <>
      <ListPanel itemType='role'
        count={data?.length || 'no'}
        search={search}
        sort={sort}
        setSearch={setSearchKeyWords}
        setSort={setSort}
      />
      {!data?.length ? (
        <Loader />
      ) : !search && data.length === 0 ? (
        <Empty
          icon={<ProfileCircleIcon width={40} height={40} />}
          title="roles"
        />
      ) : (
        <List linkToPrefix='/rbac/role'
          items={data?.sort(
            (a:IRoleRecord, b:IRoleRecord) => ( (a.sort < b.sort) ? -1 : 1)
          ) || [] }
          keys={['name', 'displayName', 'teamId', 'description']}
          page={page}
          total={data?.length}
          setPage={setPageNumber}
        />
      )}
    </>
  )
}
